module.exports = __webpack_public_path__ + "static/img/bjk1_jcjg_10_icon.png";